module.exports = __webpack_public_path__ + "media/images/rueda-e6c694f471f647b80ae65bd676983e12.svg";